module.exports = __webpack_public_path__ + "media/images/promo/championship/Steps-bf7bc7a741d8207b4b2afd597b1d4503.png";